/**
 * Enum for user permissions.
 */
export enum PermissionEnum {
  /**
   * Allows reading data.
   */
  READ = 'READ',
  /**
   * Allows writing data.
   */
  WRITE = 'WRITE',
  /**
   * Allows updating data.
   */
  UPDATE = 'UPDATE',
  /**
   * Allows deleting data.
   */
  DELETE = 'DELETE',
  /**
   * Allows resending the email confirmation.
   */
  RESEND_EMAIL_CONFIRMATION = 'RESEND_EMAIL_CONFIRMATION',
  /**
   * Allows exporting data.
   */
  EXPORT_DATA = 'EXPORT_DATA',
  /**
   * Allows changing the user status.
   */
  CHANGE_USER_STATUS = 'CHANGE_USER_STATUS',
  /**
   * Allows changing the profile email.
   */
  CHANGE_PROFILE_EMAIL = 'CHANGE_PROFILE_EMAIL',
  /**
   * Allows changing the profile password.
   */
  CHANGE_PROFILE_PASSWORD = 'CHANGE_PROFILE_PASSWORD'
}
